import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

export const reviewValidator = yupResolver(yup.object().shape({
  rating: yup.number().transform(value => (isNaN(value) ? 0 : value)).nullable().min(1, "Please chose the rating"),
}));
